import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import DivisionForm from '../DivisionForm';
import { useParams } from "react-router-dom";
import { EditMode } from "../../../enums/EditMode";
const DriverEditPage = () => {
    const params = useParams();
    return (_jsx("div", { className: "container-fluid", children: _jsxs("article", { className: "article", children: [_jsx("h2", { className: "article-title", children: "Edit Division" }), _jsx(DivisionForm, { mode: params.divisionId === "new" ? EditMode.CREATE : EditMode.EDIT, divisionId: Number(params.divisionId) })] }) }));
};
export default DriverEditPage;
